import { render, staticRenderFns } from "./DeliveryZones.vue?vue&type=template&id=12802f93&scoped=true&"
import script from "./DeliveryZones.vue?vue&type=script&lang=js&"
export * from "./DeliveryZones.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryZones.vue?vue&type=style&index=0&id=12802f93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12802f93",
  null
  
)

export default component.exports